module.exports = __webpack_public_path__ + "img/transaction.78be0d85.png";